// Dashboard static text constants (English only)
export const DASHBOARD_TEXT = {
  home: {
    accountInfoCompany: 'Bread Zeppelin, Inc.',
    accountInfoAccountId: 'Account ID: VT-819',
    accountManager: 'Account Manager',
    accountManagerName: 'Name: Alisha Suazo',
    accountManagerEmail: 'Email: alisha.suazo@verifytoday.com',
    accountManagerPhone: 'Phone: (751) 972-1053',
  },
  header: {
    greeting: (name: string) => `Hello, ${name}`,
    notifications: 'Notifications',
    appLogoAlt: 'App_logo',
  },
  sidebar: {
    dashboard: 'DASHBOARD',
    pendingActionItems: 'PENDING ACTION ITEMS',
    i9Queue: 'I-9 Queue',
    i9QueueChildren: [
      {
        label: 'I-9 Records',
        path: '/active-i9-queue',
      },
      // Client-facing digitized-I-9 list (VTK-1740).
      {
        label: 'Digitized Records',
        path: '/digitization',
      },
      {
        label: 'Storage',
        path: '/storage',
      },
      // Internal (super-admin) upload/split/extract workspace. Absorbs the former "Digitization
      // Requests" queue (VTK-1886) — super-admins digitize from Storage straight into here.
      {
        label: 'Batch Processing',
        path: '/digitization/batch',
      },
      // Client-facing remediation queue (VTK-1865/1742) — records with M-274 findings to resolve.
      {
        label: 'Remediation',
        path: '/remediation',
      },
    ],
    employees: 'Employees',
    employeesChildren: [
      {
        label: 'Invite Employee',
        path: '/employees/invite',
      },
    ],
    // Internal, super admins only (VTK-2063): one entry opening the one Visa Matrix page, whose
    // tabs are the former sublinks. The I-9 Inspector is reached from an I-9, not from here.
    visaMatrix: 'Visa Matrix',
    visaMatrixPath: '/visa-matrix/rules',
    reports: 'E-verify',
    reportsChildren: [
      {
        label: 'All E-Verify Cases',
        path: '/all-everify-cases',
      },
      {
        label: 'E-Verify Queue',
        path: '/admin/e-verify-queue',
      },
    ],
    settings: 'Settings',
    logout: 'Logout',
  },
  reportsSection: {
    title: 'Reports & Insights',
    i9Processed: 'I-9 Processed (Last 6 Months)',
    i9ProcessedTitle: 'I-9 Processed',
    statusDistribution: 'Status Distribution',
    delayedAfter3Days: 'Delayed After 3 Days',
    initiated: 'Initiated',
    inProgress: 'In Progress',
    completed: 'Completed',
    eVerified: 'E-Verified',
  },
  actionItemsSection: {
    title: 'Action Items',
    viewAllNotifications: 'View All Notifications',
    section2Pending: 'Section 2 Pending',
    section1Pending: 'Section 1 Pending',
    pendingEVerify: 'Pending E-Verify',
    ssaCases: 'SSA/DHS Cases Requiring Action',
    photoVerificationPending: 'Photo Verification Pending',
    pendingSSNSubmissions: 'Pending SSN Submissions',
    duplicateCases: 'Duplicate Cases',
    reverificationsDue: 'Reverifications Due',
    viewItems: 'VIEW ITEMS',
  },
};
